const Locations = () => {
    return <h1>this will be the locations directory page</h1>
}

export default Locations